import { render, staticRenderFns } from "./p20.vue?vue&type=template&id=729ea4f1&scoped=true&"
import script from "./p20.vue?vue&type=script&lang=js&"
export * from "./p20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729ea4f1",
  null
  
)

export default component.exports